import { createTracker } from 'usage-tracker-public';
import { createSearchParams } from '../searchParams';
import { getUuidFromUrl, resetAmplitudeStorageIfNeeded } from '../utils';
export default {
  init: options => createTracker(options),
  switch: (from, {
    history: {
      location,
      replace
    },
    storeUuidOnUrl
  }) => {
    if (from === undefined || from === 'anonymous') {
      if (storeUuidOnUrl === true) {
        const searchParams = createSearchParams(location.search);
        const uuidQueryParam = getUuidFromUrl(location);

        // If an UUID is present on the localStorage then we
        // need to erase the UUID from the Query Params
        // and do any necessary/possible cleanup
        if (uuidQueryParam !== undefined) {
          resetAmplitudeStorageIfNeeded(uuidQueryParam);
          searchParams.delete('uuid');
          const search = searchParams.toString();
          replace(`${location.pathname}${search ? `?${search}` : ''}`);
        }
      }
    }
  }
};